import { Component } from '@angular/core';

interface NewsMediaTab {
  icon: string;
  labelKey: string;
  route: string;
}

@Component({
  selector: 'news-media',
  templateUrl: './news-media.component.html',
  styleUrls: ['./news-media.component.css'],
})
export class NewsMediaComponent {
  tabs: NewsMediaTab[] = [
    {
      icon: 'assets/images/news-media/in-the-news.svg',
      labelKey: 'NEWS-MEDIA_TAB-IN-THE-NEWS',
      route: 'in-the-news',
    },
    {
      icon: 'assets/images/news-media/reports.svg',
      labelKey: 'NEWS-MEDIA_TAB-REPORTS',
      route: 'reports',
    },
    {
      icon: 'assets/images/news-media/press-releases.svg',
      labelKey: 'NEWS-MEDIA_TAB-PRESS-RELEASES',
      route: 'press-releases',
    },
  ];

  trackByRoute(_index: number, tab: NewsMediaTab): string {
    return tab.route;
  }
}
